import { request, getCompanyId } from '../utils'
import {    API_METRIC_LEADERBOARD, API_TEAM_LIST_LEADERBOARD, API_TEAM_MEMBER_LIST_LEADERBOARD, API_INDIVIDUAL_MEMBER_LIST_LEADERBOARD, DOWNLOAD_CSV_DATA_LEADERBOARD } from '../routes/api'


class LeaderBoardApi {
  
  static fetchMetricLeaderBoard(options, onSuccess, onError) {
    return request(
      { url: API_METRIC_LEADERBOARD(options.id) + '?' + getCompanyId(), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static fetchTeamListLeaderBoard(options, onSuccess, onError) {
    return request(
      { url: API_TEAM_LIST_LEADERBOARD(options.id) + '?' + getCompanyId(), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static fetchTeamListMembersLeaderBoard(options, onSuccess, onError) {
    return request(
      { url: API_TEAM_MEMBER_LIST_LEADERBOARD(options.id, options.team_id, options.term) + '&' + getCompanyId(), method: 'get', ...options },
      onSuccess,
      onError
    );
  }
  
  static fetchIndividualMembersLeaderBoard(options, onSuccess, onError) {
    return request(
      { url: API_INDIVIDUAL_MEMBER_LIST_LEADERBOARD(options.id, options.term) + '&' + getCompanyId(), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static downloadCSVDataLeaderboard(options, onSuccess, onError) {
    return request(
      { url: DOWNLOAD_CSV_DATA_LEADERBOARD(options.id, options.type) + '&' + getCompanyId(), method: 'get', ...options },
      onSuccess,
      onError
    );
  }
}

export default LeaderBoardApi